import variables from '../variables'

import type { TabsOverrideToken } from './types'

const Tabs: TabsOverrideToken = {
  colorText: variables.gray90,
  colorTextDisabled: variables.gray60,
  margin: 0
} as const

export default Tabs
